import React from "react";
import { Card, CardContent } from "./card";
import { OfferTag, type MinimalTagData } from "./offer-tag";

export interface TagListProps {
  tags: MinimalTagData[];
  className?: string;
}

export const TagList = ({ tags, className }: TagListProps) => {
  if (!tags.length) {
    return null;
  }

  return (
    <Card className={className}>
      <CardContent>
        <div className="flex flex-wrap items-center justify-around gap-4">
          {tags.map((tag) => (
            <OfferTag key={tag.id} tag={tag} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
